import {
  AlertCode,
  AlertLinkType,
  AlertsQuery,
  AlertType,
} from "@/generated/graphql_billing";
import { graphql, HttpResponse } from "msw";

export const alertsHandler = graphql.query<AlertsQuery>(
  "alerts",
  ({ query, variables }) => {
    return HttpResponse.json({
      data: {
        alerts: [
          {
            alertID: 1,
            alertType: AlertType.Warning,
            message:
              "クレジットカードの利用承認が得られませんでした。次回請求までにクレジットカード情報の更新をお願いします。期限内に修正手続きをいただけなかった場合は、サービスのご利用ができなくなります。",
            linkType: AlertLinkType.None,
            linkURL: "", //なくなる予定
            code: AlertCode.ReversalNg,
          },
          {
            alertID: 2,
            alertType: AlertType.Warning,
            message:
              "ご利用料金の請求ができませんでした。今月18日までにクレジットカード情報の更新をお願いします。期限内に修正手続きをいただけなかった場合は、来月よりサービスのご利用ができなくなります。",
            linkType: AlertLinkType.None,
            linkURL: "", //なくなる予定
            code: AlertCode.FirstBillingNg,
          },
          {
            alertID: 3,
            alertType: AlertType.Warning,
            message:
              "ご利用料金の請求ができませんでした。クレジットカード情報の更新をお願いします。また、請求書を送付いたしますので、銀行振り込みにてお支払いをお願いいたします。手続きをいただけなかった場合は、来月よりサービスのご利用ができなくなります。",
            linkType: AlertLinkType.None,
            linkURL: "", //なくなる予定
            code: AlertCode.SecondBillingNg,
          },
          {
            alertID: 4,
            alertType: AlertType.Warning,
            message:
              "ご利用料金のお支払いが確認できないため、現在サービスの利用を停止しています。クレジットカード情報の更新をお願いします。また、今月中にお支払が確認できない場合はプランの解約手続きをさせてただきます。",
            linkType: AlertLinkType.None,
            linkURL: "", //なくなる予定
            code: AlertCode.Suspended,
          },
        ],
      },
    });
  }
);

export const alertsDynamicHandler = (alertsQuery: AlertsQuery) => {
  return graphql.query<AlertsQuery>("alerts", ({ query, variables }) => {
    return HttpResponse.json({ data: alertsQuery });
  });
};
